var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8438 17.0947L4.66731 0.917338C3.96181 0.211799 2.81801 0.211799 2.11361 0.917338L1.26106 1.76862C0.555558 2.47438 0.555558 3.61823 1.26106 4.32267L17.4375 20.5C18.1433 21.2056 19.2871 21.2056 19.9915 20.5L20.8427 19.6488C21.5495 18.9443 21.5495 17.8002 20.8438 17.0947Z",
    fill: "#0EC99E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4374 0.917177L1.26106 17.0947C0.55556 17.8002 0.55556 18.9443 1.26106 19.6487L2.11228 20.5C2.818 21.2056 3.96178 21.2056 4.66618 20.5L20.8437 4.32364C21.5494 3.61809 21.5494 2.47423 20.8437 1.76978L19.9924 0.9185C19.2869 0.211632 18.1431 0.211632 17.4374 0.917177Z",
    fill: "#0EC99E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/closeIcon.23ee4ff52d1ef703c81970e7e7731203.svg";
export { ForwardRef as ReactComponent };